export default [
  {
    id: 1,
    title: "MOT System",
    image: "https://www.fau.edu/engineering/senior-design/images/spring2023-poster-images/35.jpg",
    summary: "Project FrontEnd Leader",
    pathname: "project-1",
    objective:
      "Leading Team 18, I orchestrated the development of a sophisticated system for Florida Power & Light to enhance worker safety by detecting vehicles entering maintenance zones. My key role involved steering both frontend and backend development, ensuring the seamless integration of cutting-edge technologies including microcontrollers and lidar sensors for real-time vehicle tracking. Our coordinated efforts and technical prowess led to the successful creation of a robust system, achieving FPL’s objectives and demonstrating our commitment to innovation and safety.",
    lesson: "During this project, I deepened my knowledge of React and JavaScript, honing my skills in crafting responsive interfaces. I familiarized myself with MongoDB for effective database management and AWS for secure cloud solutions. Exploring Python, I tackled backend challenges and mastered the creation and utilization of APIs, crucial for real-time data transfer. Additionally, I gained insights into embedded systems, learning to integrate microcontrollers with sensors for real-time monitoring. This experience was pivotal in broadening my technical skill set and preparing me for future technological endeavors.",
    video: "https://www.youtube.com/embed/XZZJnXHtNDI"
  },
  {
    id: 2,
    title: "Property Database",
    image:
      "https://slopeside-engineers.com/wp-content/uploads/2022/11/Modern-Home-980x603.jpg",
    summary: "Project Leader ",
    date: "",
    objective: "****VIDEO COMING SOON**** In this project, I assumed the role of team leader, guiding our group in developing a tailored property management database. Our objective was to enable users to catalog items for their properties and track associated costs seamlessly. I was instrumental in instilling structure and orchestrating the project, organizing sprints, and ensuring team accountability to meet our deadlines. I assigned each member specific tasks to create individual components and educated them on the importance of functional programming in React, as it was their first encounter with the framework. Being at the forefront of both frontend and backend development, I ensured the seamless integration and functionality of the entire system.",
    lesson: "",
    video: ""
  },
  {
    id: 3,
    title: "Instagram Clone",
    image:
      "https://user-images.githubusercontent.com/81199017/196583349-e977c918-f1c8-4733-a9c6-3a4960d4b26d.gif",
    summary: "School Project",
    date: "",
    objective: "****VIDEO COMING SOON**** In today's video, I'm super excited to show you a clone of Instagram that I built for my homework assignment using SwiftUI. So first off, I made sure that once you log in, you'll stay logged in even after restarting the app. Super convenient, right? And of course, you can log out whenever you want. You can view and add comments on posts, so you can interact with your friends and the whole community. Hope you guys like it! If you do, give this video a thumbs up. Thanks for watching!",
    lesson: "",
    video: ""
  },
  {
    id: 4,
    title: "Movie Project",
    image:
      "https://user-images.githubusercontent.com/81199017/190042874-98d15526-e9d4-41aa-b5e6-ca254534c422.gif",
    summary: "School Project",
    date: "",
    objective: "****VIDEO COMING SOON**** Hey everyone, welcome back to my channel! Today, I'm excited to share with you a project I've been working on called Flix, where I built a local movie app that pulls data from current movies in theaters using an API. In this app, you can tap on any movie cell to see more details about it, like the showtimes and locations. That's not all - I also included reviews from Rotten Tomatoes, so you can see what critics are saying about the movie. But wait, there's more! You can also tap on a tab bar button to view a grid layout of movie posters using a CollectionView. I hope you guys like this walkthrough of Flix.",
    lesson: "",
    video: ""
  },
  // {
  //   id: 5,
  //   title: "Simon Game",
  //   image: "https://i.ibb.co/9816Xsf/Screen-Shot-2023-09-25-at-5-38-45-PM.png",
  //   summary: "Personal Project",
  //   date: "",
  //   objective: "",
  //   lesson: "",
  //   video: ""
  // },
];
//
